import React, { useState } from 'react';
import { X } from 'lucide-react';
import Reveal from '../components/Reveal';
import PageHeader from '../components/PageHeader';
import { Dialog, DialogContent } from '../components/ui/dialog';
import { images, galleryItems, videos } from '../mock';

const Gallery = () => {
  const [active, setActive] = useState(null);

  return (
    <div>
      <PageHeader
        eyebrow="Gallery"
        title="In the field"
        image={images.openPit}
      />

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {galleryItems.map((item, i) => (
              <Reveal key={i} delay={(i % 4) * 70}>
                <button
                  onClick={() => setActive(item)}
                  className={`group relative w-full overflow-hidden ${i % 5 === 0 ? 'md:col-span-2 md:row-span-2' : ''}`}
                >
                  <img
                    src={images[item.img]}
                    alt={item.title}
                    className={`w-full object-cover group-hover:scale-105 transition-transform duration-1000 ${
                      i % 5 === 0 ? 'h-full min-h-[300px]' : 'h-64'
                    }`}
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/25 transition-colors duration-500" />
                </button>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="pb-28 bg-white" data-testid="gallery-film-section">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Reveal>
            <div className="eyebrow text-amber-700 mb-4">On Film</div>
            <h2 className="font-display text-3xl md:text-5xl font-medium text-neutral-900 mb-14">
              From the air.
            </h2>
          </Reveal>
          <div className="space-y-20">
            {videos.slice(1).map((v, i) => (
              <Reveal key={v.src} delay={120}>
                <div className="eyebrow text-neutral-500 mb-4">{v.title}</div>
                <div className="relative w-full overflow-hidden bg-black shadow-2xl">
                  <video
                    src={(process.env.PUBLIC_URL || '') + v.src}
                    poster={v.posterUrl}
                    controls
                    playsInline
                    preload="none"
                    className="w-full aspect-video bg-black"
                    data-testid={`gallery-video-${i + 1}`}
                  />
                </div>
                <p className="mt-4 text-neutral-500 text-sm">{v.subtitle}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-4xl p-0 border-0 bg-neutral-950 overflow-hidden">
          {active && (
            <div>
              <img src={images[active.img]} alt="" className="w-full max-h-[80vh] object-contain bg-black" />
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Gallery;
